import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Award, GraduationCap } from "lucide-react";
import miracleCoatBooth from "@/assets/miracle-coat-booth.png";
const MiracleCoat = () => {
  return <section className="py-24 bg-background relative overflow-hidden">
      {/* Subtle glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-3xl" />

      <div className="container relative">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-2 lg:order-1">
            <img src={miracleCoatBooth} alt="Miracle Coat trade show booth with Hyper Haus" loading="lazy" width={596} height={415} className="w-full rounded-lg" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-1 lg:order-2">
            <div className="flex items-center gap-3 mb-4">
              <Award className="w-6 h-6 text-primary" />
              <p className="text-primary text-sm uppercase tracking-[0.3em]">MIRACLE COAT EXCLUSIVE</p>
            </div>
            <h2 className="section-heading mb-6">MANUFACTURE DIRECT<br />
              
            </h2>
            <div className="space-y-4 text-muted-foreground">
              <p>We work directly with Miracle Coat, the South Korean manufacturer of premium paint protection film and tint. Hyper Haus is their premiere OEM install location and only certified training site in the United States. This direct partnership ensures the highest quality of material and craftsmanship.</p>
              <p>
            </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mt-8">
              <Link to="/automotive/ppf" className="btn-hero-primary text-sm">
                Learn About PPF <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/training" className="btn-hero-outline text-sm">
                <GraduationCap className="w-4 h-4" />
                Installer Training
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default MiracleCoat;